module.exports = __webpack_public_path__ + "img/nian.231d578a.png";